class State {
	name: string;
	id: string;
	color: string;

	constructor(name: string, id: string, color: string) {
		this.name = name;
		this.id = id;
		this.color = color;
	}

	static allStates: Array<State> = [
		new State('Late', 'LATE', '#FF9944'),
		new State('Done', 'DONE', '#44BB44'),
		new State('Planned', 'COMING', '#33BBDD'),
		new State('Not Done', 'NOT_DONE', '#FF5555'),
		new State('Unplanned', 'UNPLANNED', '#FFAA00'),
	];

	static getStateByID(id: string) {
		return this.allStates.find(state => state.id === id);
	}

	static statusToState(id: string) {
		return this.getStateByID(id)?.name;
	}

	static statusToColor(id: string) {
		return this.getStateByID(id)?.color;
	}
}

export default State;